<template>
  <ul
    v-if="products.length"
    class="products seasidetms_products col-md-12"
    :class="columnsCount"
  >
    <product-tile
      v-for="(product, index) in products"
      :key="product.slug"
      :product="product"
      :index="index"
    />
  </ul>
  <div v-else class="emptylist">
    <span>{{ $t('emptyCategory') }}</span>
  </div>
</template>

<script>
import ProductTile from '@/components/product/ProductTile'

export default {
  name: 'ProductsListTiles',
  components: { ProductTile },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
    cols: {
      type: String,
    },
  },
  computed: {
    columnsCount() {
      return this.cols ? this.cols : 'columns-3'
    },
  },
}
</script>

<style></style>
